export default {"src":"/org/_next/static/media/info.5da94a34.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};